import { AppType } from "client/Api/Apps/common";
import { ReactElement } from "react";
import { useRenderManager } from "../../useRenderManager";
import { YouTubeLiveTileContent } from "./YouTubeLiveTileContent";
import { TileRenderState } from "../../RenderState/common";
import { TileContextProvider } from "../../TileContextProvider";
import { Coordinate } from "client/Misc/commonTypes";

export type YouTubeTileContentProps = {
	renderState: TileRenderState<AppType.YouTube>;
	onOpenTileMenu: (coordinate: Coordinate) => void;
};

export const YouTubeTileContent = (props: YouTubeTileContentProps): ReactElement => {
	const {
		renderState,
		onOpenTileMenu
	} = props;

	const {
		dimension,
		data: { settings }
	 } = renderState;

	const tileContent: ReactElement = useRenderManager(
		dimension,
		() => (
			<YouTubeLiveTileContent
				settings={settings}
				onOpenTileMenu={onOpenTileMenu}
			/>
		)
	);

	return (
		<TileContextProvider
			renderState={renderState}
		>
			{tileContent}
		</TileContextProvider>
	);
};
YouTubeTileContent.displayName = "YouTubeTileContent";
